export default function () {
  $(document).ready(function () {
    if ($('.quicklocationselectsearch').length) {
      $('.quicklocationselectsearch').each(function () {
        var form = $(this),
          kind = form.children('.quicklocationselectsearch__kind'),
          region = form.children('.quicklocationselectsearch__region'),
          kindchoice = kind.children('option').filter(':selected').val(),
          regionchoice = region.children('option').filter(':selected').val(),
          submitbutton = form.children('.quicklocationselectsearch__submit')

        submitbutton.on('click', function (e) {
          e.preventDefault()
          // kind is always chosen but in the case where region isn't
          //kindchoice = kind.children('option').filter(':selected').val()
          //regionchoice = region.children('option').filter(':selected').val()
          regionchoice = $('.quicklocationselectsearch__region').val()
          kindchoice = $('.quicklocationselectsearch__kind').val()
          if (regionchoice === '' || regionchoice === false || regionchoice === undefined) {
            window.alert('Please select a region')
            region.focus()
          } else {
            window.location.href = '/' + kindchoice + '?regions=' + regionchoice
          }
        })
      })
    }
  })
}
